import React, { useState } from 'react';
import { useAuth } from '../App';
import { Button, Input, Card } from '../components/UI';
import { FileText } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

export const Login: React.FC = () => {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    const err = await login(email, password);
    setLoading(false);
    if (err) setError(err);
    else navigate('/');
  };

  return (
    <div className="min-h-screen bg-slate-100 flex items-center justify-center p-4">
      <div className="max-w-md w-full">
        <div className="flex justify-center mb-8">
           <div className="flex items-center gap-2 text-accent">
            <FileText className="h-10 w-10" />
            <span className="text-3xl font-bold text-slate-900">Money Bamboney</span>
          </div>
        </div>
        <Card className="shadow-lg">
          <form onSubmit={handleSubmit} className="space-y-6">
            <h2 className="text-2xl font-bold text-center text-slate-900">Вход в систему</h2>

            <Input label="Email" type="email" autoComplete="email" value={email} onChange={e => setEmail(e.target.value)} required />
            <Input label="Пароль" type="password" autoComplete="current-password" value={password} onChange={e => setPassword(e.target.value)} required />

            {error && <div className="text-red-500 text-sm text-center">{error}</div>}

            <Button type="submit" className="w-full" size="lg" disabled={loading}>
              Войти
            </Button>

            <p className="text-sm text-slate-500 text-center">Учётную запись выдаёт администратор</p>
          </form>
        </Card>
      </div>
    </div>
  );
};
